module.exports = __webpack_public_path__ + "static/media/clear sky 01d.ff33f0de.png";